"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHelixmithReportSheets = void 0;
var Translation_1 = require("../Translation");
var HelixmithControl = __importStar(require("../control/HelixmithControl"));
var ReportSheet_1 = require("./ReportSheet");
var HelixmithSheetDesignEvaluation = {
    name: 'DesignEvaluation',
    columnSize: [2, 24, 24, 24, 15, 15, 15, 15, 15, 15],
    paddingColumnCount: 1,
    defaultRowHeight: 15,
    paddingRowCount: 2,
    rowClusters: [
        // 내부회계~
        {
            rows: [
                {
                    description: '상단 타이틀',
                    height: 100,
                    cells: [
                        {
                            style: ReportSheet_1.CELL_STYLE_A,
                            value: '내부회계관리제도 설계의 효과성 평가(일반_PLC,ITGC)',
                            cellSize: 9
                        }
                    ]
                }
            ]
        },
        // 대분류~
        {
            rows: [
                {
                    description: '대분류 라인',
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('common', 'cycleName') },
                        {
                            key: 'content.control.cycleName',
                            cellSize: 8
                        }
                    ]
                },
                {
                    description: '중분류 라인',
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('common', 'categoryName') },
                        { key: 'content.control.categoryName', cellSize: 4 },
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('common', 'updateTime') },
                        { key: 'content.data.updateTime', cellSize: 3 }
                    ]
                },
                {
                    description: '프로세스 라인',
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('common', 'processCode') },
                        { key: 'content.processCode', cellSize: 4 },
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('control', 'performer') },
                        { key: 'state.performer', cellSize: 3 }
                    ]
                },
                {
                    description: '통제담당부서 라인',
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('control', 'departmentInRCM') },
                        { key: 'content.control.department', cellSize: 4 },
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('control', 'owner') },
                        { key: 'content.control.owner', cellSize: 3 }
                    ]
                }
            ]
        },
        // 위험코드~
        {
            rows: [
                {
                    description: '위험코드 라인',
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('risk', 'id') },
                        { key: 'content.risk.id' },
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('risk', 'name') },
                        { key: 'content.risk.name', cellSize: 6 }
                    ]
                },
                {
                    description: '통제번호 라인',
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('control', 'id') },
                        { key: 'content.data.controlId' },
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('control', 'name') },
                        { key: 'content.control.name', cellSize: 6 }
                    ]
                },
                {
                    description: '통제활동 설명 라인',
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('control', 'narrative') },
                        { key: 'content.control.narrative', cellSize: 8 }
                    ]
                },
                {
                    // NOTE: HelixmithControl.ts 와 대응
                    description: '통제유형 라인',
                    rowSize: 2,
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: '통제유형' },
                        { style: ReportSheet_1.CELL_STYLE_B, value: (0, Translation_1.getKoName)('control', 'keyControl') },
                        { key: 'content.control.keyControl' },
                        { style: ReportSheet_1.CELL_STYLE_B, value: (0, Translation_1.getKoName)('control', 'autoManual') },
                        { key: 'content.control.autoManual' },
                        { style: ReportSheet_1.CELL_STYLE_B, value: (0, Translation_1.getKoName)('control', 'preventDetective') },
                        { key: 'content.control.preventDetective' },
                        { style: ReportSheet_1.CELL_STYLE_B, value: (0, Translation_1.getKoName)('control', 'period') },
                        { key: 'content.control.period' }
                    ]
                },
                {
                    // NOTE: HelixmithControl.ts 와 대응
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: '통제유형' },
                        { style: ReportSheet_1.CELL_STYLE_B, value: (0, Translation_1.getKoName)('risk', 'inherentRiskLevel') },
                        { key: 'content.risk.inherentRiskLevel', cellSize: 3 },
                        { style: ReportSheet_1.CELL_STYLE_B, value: (0, Translation_1.getKoName)('control', 'residualRiskLevel') },
                        { key: 'content.control.residualRiskLevel', cellSize: 3 }
                    ]
                }
            ]
        },
        // 통제담당자~
        {
            rows: [
                {
                    description: '통제담당자 평가 라인',
                    height: 30,
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('control', 'OwnerAssessment') },
                        { key: 'content.data.ownerAssessment', cellSize: 8 }
                    ]
                },
                { cells: [] }
            ]
        },
        // 통제활동~
        { rows: (0, ReportSheet_1.makeConsiderationResults)(HelixmithControl.CONSIDERATIONS) },
        // 통제평가절차
        {
            rows: [
                {
                    description: '통제평가절차 라인',
                    height: 35,
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: '' },
                        {
                            style: ReportSheet_1.CELL_STYLE_B,
                            value: (0, Translation_1.getKoName)('control', 'TOC_ProcedureContent'),
                            cellSize: 1
                        },
                        {
                            key: 'content.data.procedureContent',
                            cellSize: 7
                        }
                    ]
                },
                {
                    description: '통제평가절차 라인',
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: '' },
                        {
                            style: ReportSheet_1.CELL_STYLE_B,
                            value: '검토증빙 문서',
                            cellSize: 1
                        },
                        {
                            value: '증빙문서 시트 참고',
                            cellSize: 7
                        }
                    ]
                }
            ]
        },
        // 평가 결론
        {
            rows: [
                {
                    description: '평가 결론 라인',
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: '평가 결론' },
                        {
                            style: ReportSheet_1.CELL_STYLE_A,
                            key: 'state.resultState',
                            formatter: function (numStr) {
                                if (numStr === '2') {
                                    return 'Effective';
                                }
                                else {
                                    return 'Ineffective';
                                }
                            }
                        }
                    ]
                }
            ]
        }
    ]
};
var HelixmithSheetFileInfo = {
    name: 'FileInfo',
    columnSize: [85, 28, 28, 28],
    paddingColumnCount: 0,
    defaultRowHeight: 15,
    paddingRowCount: 0,
    rowClusters: [
        {
            rows: [
                {
                    description: '헤더',
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('common', 'fileName') },
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('common', 'type') },
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('common', 'updater') },
                        { style: ReportSheet_1.CELL_STYLE_A, value: (0, Translation_1.getKoName)('common', 'updateTime') }
                    ]
                }
            ]
        }
    ]
};
var HelixmithSheetRcmModification = {
    name: 'RcmModification',
    columnSize: [2, 25, 40, 50, 50],
    paddingColumnCount: 1,
    defaultRowHeight: 15,
    paddingRowCount: 1,
    rowClusters: [
        // 통제 정보 업데이트~
        {
            rows: [
                {
                    description: '상단 타이틀 - 통제 정보 업데이트',
                    height: 70,
                    cells: [
                        {
                            style: ReportSheet_1.CELL_STYLE_A,
                            value: '통제 정보 업데이트',
                            cellSize: 4
                        }
                    ]
                }
            ]
        },
        // 통제 정보 내용~
        {
            rows: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
                {
                    description: '기존 통제 정보 라인',
                    height: 35,
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_B, value: '기존 통제 정보', cellSize: 2 },
                        { style: ReportSheet_1.CELL_STYLE_B, value: '수정된 통제 내용' },
                        { style: ReportSheet_1.CELL_STYLE_B, value: '수정 근거' }
                    ]
                },
                {
                    description: '기존 RCM 상 존재하였던 통제 정보 라인',
                    height: 20,
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: '기존 RCM 상 존재하였던 통제 정보', cellSize: 2 },
                        { style: ReportSheet_1.CELL_STYLE_A, value: '당 설계평가에서 수정된 RCM 정보' },
                        { style: ReportSheet_1.CELL_STYLE_A, value: '수정된 RCM 정보의 근거' }
                    ]
                }
            ], (0, ReportSheet_1.convertEditedRCM)({
                headline: '통제기본정보',
                contents: [
                    { PRC: 'control', key: 'id' },
                    { PRC: 'control', key: 'name' },
                    { PRC: 'control', key: 'narrative', rowHeight: 300 },
                    { PRC: 'control', key: 'keyControl' },
                    { PRC: 'control', key: 'period' },
                    { PRC: 'control', key: 'preventDetective' },
                    { PRC: 'control', key: 'autoManual' }
                ]
            }), true), (0, ReportSheet_1.convertEditedRCM)({
                headline: '규정 및 자원',
                contents: [
                    { PRC: 'control', key: 'policy' },
                    { PRC: 'control', key: 'ITDependencySystem' }
                ]
            }), true), (0, ReportSheet_1.convertEditedRCM)({
                headline: 'MRC',
                contents: [
                    { PRC: 'control', key: 'MRC_YN' },
                    { PRC: 'control', key: 'IPE_Number' },
                    { PRC: 'control', key: 'IPE_Name' },
                    { PRC: 'control', key: 'IPE_Testing' },
                    { PRC: 'control', key: 'euc_name' },
                    { PRC: 'control', key: 'EUC_Testing' }
                ]
            }), true), (0, ReportSheet_1.convertEditedRCM)({
                headline: '통제 조직',
                contents: [
                    { PRC: 'control', key: 'department_description' },
                    { PRC: 'control', key: 'teamLeader' },
                    { PRC: 'control', key: 'teamMember' },
                    { PRC: 'control', key: 'incharge' },
                    { PRC: 'control', key: 'owner' }
                ]
            }), true), (0, ReportSheet_1.convertEditedRCM)({
                headline: '기타 통제 속성',
                contents: [
                    { PRC: 'control', key: 'residualRiskLevel' },
                    { PRC: 'control', key: 'accountName' },
                    { PRC: 'control', key: 'reportFootnotes' }
                ]
            }), true), (0, ReportSheet_1.convertEditedRCM)({
                headline: '경영진주장',
                contents: [
                    { PRC: 'control', key: 'assertion_EO' },
                    { PRC: 'control', key: 'assertion_Occur' },
                    { PRC: 'control', key: 'assertion_C' },
                    { PRC: 'control', key: 'assertion_Measurement' },
                    { PRC: 'control', key: 'assertion_Assessment' },
                    { PRC: 'control', key: 'assertion_RO' },
                    { PRC: 'control', key: 'assertion_PD' }
                ]
            }), true), (0, ReportSheet_1.convertEditedRCM)({
                headline: '관련 위험',
                contents: [
                    { PRC: 'risk', key: 'id' },
                    { PRC: 'risk', key: 'name', rowHeight: 30 },
                    { PRC: 'risk', key: 'inherentRiskLevel' }
                ]
            }), true)
        },
        // 통제 평가 방법 업데이트~
        {
            rows: [
                {
                    description: '상단 타이틀 - 통제 평가 방법 업데이트',
                    height: 70,
                    cells: [{ style: ReportSheet_1.CELL_STYLE_A, value: '통제 평가 방법 업데이트', cellSize: 4 }]
                }
            ]
        },
        // 통제 평가 방법 내용~
        {
            rows: __spreadArray([
                {
                    description: '기존 통제 정보 라인',
                    height: 35,
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_B, value: '기존 통제 정보', cellSize: 2 },
                        { style: ReportSheet_1.CELL_STYLE_B, value: '수정된 통제 내용' },
                        { style: ReportSheet_1.CELL_STYLE_B, value: '수정 근거' }
                    ]
                },
                {
                    description: '기존 RCM 상 존재하였던 통제 정보 라인',
                    height: 20,
                    cells: [
                        { style: ReportSheet_1.CELL_STYLE_A, value: '기존 RCM 상 존재하였던 통제 정보', cellSize: 2 },
                        { style: ReportSheet_1.CELL_STYLE_A, value: '당 설계평가에서 수정된 RCM 정보' },
                        { style: ReportSheet_1.CELL_STYLE_A, value: '수정된 RCM 정보의 근거' }
                    ]
                }
            ], (0, ReportSheet_1.convertEditedRCM)({
                headline: '통제운영속성',
                contents: [
                    { PRC: 'control', key: 'TOC_Procedure' },
                    { PRC: 'control', key: 'TOC_Evidence' },
                    { PRC: 'control', key: 'TOC_Population' },
                    { PRC: 'control', key: 'TOC_Completeness' },
                    { PRC: 'control', key: 'TOC_PopulationCount' }
                ]
            }), true)
        }
    ]
};
function getHelixmithReportSheets() {
    return [HelixmithSheetDesignEvaluation, HelixmithSheetFileInfo, HelixmithSheetRcmModification];
}
exports.getHelixmithReportSheets = getHelixmithReportSheets;
//# sourceMappingURL=HelixmithReport.js.map